<template src="./privateEvent.html"></template>

<script>
  // Third party Imports
  import axios from 'axios';

  // Components Imports
  import MagicVueInput from '../MagicInput.vue';

  // Services Imports
  import { eventService } from "@/services";

  // Scss Imports
  import "./privateEvent.scss";

  export default {
    components: {
      MagicVueInput
    },
    props: {
      event: {
        type: Object
      }
    },
    data() {
      return {
        passcode: ''
      }
    },
    methods: {
      matchPasscode() { console.log("dsdsdsds")
        if (this.event.passcode === this.passcode) {
          this.$emit("passcodeVerified", true)
        } else {
          this.$toast.error("Provided passcode is incorrect", { timeout: 4000 });
        }
      }
    },
    mounted() {
      console.log("===================",this.event)
    }
  }
</script>
